/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-PIM Product Category API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v2
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * CategorizationAPIApi - axios parameter creator
 * @export
 */
export const CategorizationAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The results contains category codes as identifier for each category
         * @summary REST.API.PIM.CAT.28 Export categories
         * @param {string} [accept] text/csv
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportDpCategories: async (accept?: string|null, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/category/v2/dp_managed_category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accept !== undefined && accept !== null) {
                localVarHeaderParameter['Accept'] = String(accept);
            }

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategorizationAPIApi - functional programming interface
 * @export
 */
export const CategorizationAPIApiFp = function(configuration?: Configuration) {
    return {
        /**
         * The results contains category codes as identifier for each category
         * @summary REST.API.PIM.CAT.28 Export categories
         * @param {string} [accept] text/csv
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportDpCategories(_axios: AxiosInstance, accept?: string|null, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await CategorizationAPIApiAxiosParamCreator(configuration).exportDpCategories(accept, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CategorizationAPIApi - object-oriented interface
 * @export
 * @class CategorizationAPIApi
 * @extends {BaseAPI}
 */
export class CategorizationAPIApi extends BaseAPI {
    /**
     * The results contains category codes as identifier for each category
     * @summary REST.API.PIM.CAT.28 Export categories
     * @param {string} [accept] text/csv
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategorizationAPIApi
     */
     public exportDpCategories(accept?: string|null, x_dp_customer_code?: string|null, options?: any) {
        return CategorizationAPIApiFp(this.configuration).exportDpCategories(this.axios, accept, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

}
